import { $service } from '@xt/client/experimental/request/service'
import $global from '@xt/client/store/global'

export const getStaticJson = async <T>(url: string): Promise<T | void> => {
  const [err, data] = await $service<T>({
    method: 'GET',
    url,
    baseURL: $global.static
  })

  if (data) {
    return data
  }
}
